var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-content"},[_c('b-icon',{attrs:{"icon":_vm.icon,"pack":_vm.pack}}),_c('p',[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }